import React from "react";
import "./index.css";
import Navigation from "./Navigation";
import Notfound from "./notfound";
import Home from "./pages/Home";

import Projects from "./pages/Projects";
import About from "./pages/About";


import { Route, Routes, BrowserRouter as Router } from "react-router-dom";

class App extends React.Component{
    render(){
        return(
            <Router>
                <div id="body">
                <Navigation />
                <Routes>
                    <Route exact path="/" element={<Home />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/about" element={<About />} />
                    <Route path="*" element={<Notfound />} />
                </Routes>
                </div>
            </Router>
        )
    }
}
export default App;


